import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TableConfig } from '../phoenix-table/phoenix-table.interface';

@Component({
  selector: 'app-dropdown-search-table',
  templateUrl: './dropdown-search-table.component.html',
  styleUrls: ['./dropdown-search-table.component.scss']
})
export class DropdownSearchTableComponent implements OnInit {
  
  // Dropdown Title
  @Input() searchTitle: string;
  // Dropdown subtitle
  @Input() subtitle: string;
  // Add chackbox to dropdown search
  @Input() checkbox: boolean = false;
  // Give the checkboxe some text
  @Input() checkboxDescription: string = 'checkbox description';
  // Provide an array of dropdown items.
  // Each item should have properties defined by dropdownNameField and dropdownValueField.
  @Input() dropdownData: any[] = [];
  // Property name to use for the display text in the dropdown.
  @Input() dropdownNameField: string = 'name';
  // Property name to use for the value that is displayed in the table.
  @Input() dropdownValueField: string = 'value';
  // Optional custom table configuration for your Phoenix Table.
  // Constrain T to Record<string, any> so that keys are strings.
  @Input() tableConfig?: TableConfig<Record<string, any>>;
  // Optional table header text.
  @Input() tableHeader: string = 'Selected Item';


  // Output checkbox value 
  @Output() checkboxchange: EventEmitter<boolean> = new EventEmitter<boolean>();

  searchText: string = '';
  selectedItem: any = null;
  filteredItems: any[] = [];
  dropdownVisible: boolean = false;

  ngOnInit(): void {
    // Initialize the filtered items with the provided dropdownData.
    this.filteredItems = this.dropdownData;

    // Generate a default table configuration if none is provided and there is data.
    if (!this.tableConfig && this.dropdownData.length > 0) {
      const firstItemValue = this.dropdownData[0][this.dropdownValueField];
      const columns = Object.keys(firstItemValue).map(key => ({
         key: key,
         title: key.charAt(0).toUpperCase() + key.slice(1),
         sortable: true
      }));
      this.tableConfig = {
         columns: columns,
         hasActions: false,
         emptyMessage: 'No data available',
         initialMessage: 'Please select an item',
         defaultColumnSort: columns[0].key,
         defaultSortOrder: 'asc',
         trackBy: (index: number, item: any) => index,
         containerHeight: 80 
      };
    }
  }

  // Filter dropdown items based on the search text.
  onSearchChange(): void {
    const term = this.searchText.trim().toLowerCase();
    if (term === '') {
      this.filteredItems = this.dropdownData;
      this.dropdownVisible = false;
      return;
    }
    this.filteredItems = this.dropdownData.filter(item =>
      item[this.dropdownNameField].toLowerCase().includes(term)
    );
    this.dropdownVisible = this.filteredItems.length > 0;
  }

  // When an item is selected from the dropdown.
  selectItem(item: any): void {
    this.selectedItem = item;
    this.searchText = item[this.dropdownNameField];
    this.dropdownVisible = false;
  }

  // Clears the search input and selection.
  clearSearch(): void {
    this.searchText = '';
    this.selectedItem = null;
    this.filteredItems = this.dropdownData;
    this.dropdownVisible = false;
  }

  // Get value when checkbox changes
  onCheckboxChange(event: Event): void {
    const _newValue = (event.target as HTMLInputElement).checked;
    this.checkboxchange.emit(_newValue);
  }

  // keep track of list items between re-renders and avoid unnecessary DOM updates.
  trackByFn(index: number, item: any): any {
    return item && item[this.dropdownNameField] ? item[this.dropdownNameField] : index;
  }  
}